import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import arrowIcon from './i/arrow.svg'

import styles from './TopBar.module.scss'

const TopBar = ({ currentStep, stepsCount, onNext, isCanGoNext = false, nextButtonText }) => {
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(false)

    const onHandleNext = async () => {
        try {
            setIsLoading(true)
            await onNext()
        } catch (err) {
            console.error(err)
        } finally {
            setIsLoading(false)
        }
    }

    if (!stepsCount) return null

    return (
        <div className={classNames(styles.topBar, { [styles.isCenteredTopBar]: !onNext })}>
            <div className={styles.stepNumber}>
                {currentStep}/{stepsCount}
            </div>
            <ul className={styles.stepLines}>
                {Array(stepsCount)
                    .fill('')
                    .map((_, index) => (
                        <li
                            key={index}
                            className={classNames(styles.stepLine, {
                                [styles.isActiveStepLine]: index + 1 <= currentStep,
                            })}
                        ></li>
                    ))}
            </ul>
            {!!onNext && (
                <button
                    className="button"
                    data-variant="primary"
                    disabled={!isCanGoNext || isLoading}
                    data-size="md"
                    onClick={onHandleNext}
                >
                    {nextButtonText || t('Next')}
                    <img className={styles.buttonArrow} src={arrowIcon} alt="arrow" />
                </button>
            )}
        </div>
    )
}

export default TopBar
